import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import Login from "./page/Login/Login";
import Dashboard from "./page/Dashboard/Dashboard";
import { AuthProvider } from "./auth/authContext";
import ProtectedRoute from "./component/ProtectedRoutes";
import { dashboardPath } from "./page/Dashboard/dashboardPath";
import { ToastProvider } from "./component/ToastBar";
import LoginChangePassword from "./page/Login/LoginChangePassword";

function App() {
  const dashboard = dashboardPath().flatMap((path) => path.subPaths);
  const dashboardRoutes = dashboard.map((path) => {
    return (
      <Route
        key={path.name}
        index={path.index}
        path={`/dashboard/${path.path}`}
        element={path.element}
      />
    );
  });
  return (
    <AuthProvider>
      <ToastProvider>
        <Router>
          <Routes>
            <Route
              key="dashboard"
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            >
              {/* dashboard子路由 */}
              {dashboardRoutes}
            </Route>
            <Route key="login" path="/login" element={<Login />} />
            <Route
              key="login-change-password"
              path={`change-password`}
              element={<LoginChangePassword />}
            />
            <Route key="index" path="/" element={<Login />} />
          </Routes>
        </Router>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
